// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KitPurchase_wrapper__3kepm"};